// Sunworker Logo — rising sun with construction-worker glyph (PNG, transparent background)
import React from "react";

export const SunworkerLogo = ({ size = 32 }) => (
  <img src="/branding/sunworker6-logo-icon.png" alt="Sunworker" width={size} height={size}
       style={{ width: size, height: size, objectFit: "contain" }} data-testid="sunworker-logo" />
);

export const SunworkerWordmark = ({ className = "" }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <SunworkerLogo size={32} />
    <div className="leading-tight">
      <div className="font-heading font-extrabold text-sm tracking-tight">Sunworker</div>
      <div className="font-mono text-[9px] text-eb-muted">KI &amp; IT · easybooking Edition</div>
    </div>
  </div>
);
